import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export type ServiceManager = {
  id: string;
  name: string;
};

@Component({
  selector: 'markant-platform-service-responsibility-dialog',
  templateUrl: './service-responsibility-dialog.component.html',
  styleUrls: ['./service-responsibility-dialog.component.scss'],
})
export class ServiceResponsibilityDialogComponent implements OnChanges {
  @Input({ required: true }) serviceManager!: string;
  @Input() isLoading = false;
  @Input() data: ServiceManager[] = [];

  @Output() saved = new EventEmitter<ServiceManager>();
  @Output() closed = new EventEmitter<void>();

  selectedServiceManager?: ServiceManager = undefined;
  filteredServiceManagers: ServiceManager[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.resetFilteredValues();
    }
  }

  onClose(): void {
    this.closed.emit();
  }

  onValueChanged(textSearch: string): void {
    if (textSearch.length) {
      this.filteredServiceManagers = [
        ...this.data.filter(user => user.name.toLowerCase().includes(textSearch.toLowerCase())),
      ];
      return;
    }

    this.selectedServiceManager = undefined;
    this.resetFilteredValues();
  }

  onServiceManagerSelected(id: string): void {
    this.selectedServiceManager = this.data.find(item => item.id === id);
  }

  onClearServiceManager(): void {
    this.selectedServiceManager = undefined;
    this.resetFilteredValues();
  }

  onSave(): void {
    if (this.selectedServiceManager) {
      this.saved.emit(this.selectedServiceManager);
    }
  }

  private resetFilteredValues(): void {
    this.filteredServiceManagers = [...this.data];
  }
}
